// consoleTally — how many errors and warnings this session has logged.
//
// The docked shell's console strip shows live error/warning counts. They must be
// REAL counts of what actually hit the console — a hardcoded "0 errors" is
// exactly the fake-data anti-pattern the UX rules ban — so this wraps
// console.error/console.warn once at install and counts pass-through calls.
//
// Deliberately count-only. The strip is a tally, not a log viewer; the full text
// stays in devtools where it already lives. React Flow warnings are already
// swallowed upstream by main.jsx's console.warn wrapper (installed BEFORE this
// one), so they never reach this count — which is correct, because they never
// reach the console either.

let _errors = 0
let _warnings = 0
let _installed = false
const listeners = new Set()

function notify() {
  for (const fn of listeners) fn(consoleTally.get())
}

export const consoleTally = {
  /** Idempotent — the second install is a no-op, so StrictMode/HMR can't double-wrap. */
  install() {
    if (_installed || typeof console === 'undefined') return
    _installed = true
    const err = console.error.bind(console)
    const warn = console.warn.bind(console)
    console.error = (...args) => { _errors += 1; notify(); err(...args) }
    console.warn = (...args) => { _warnings += 1; notify(); warn(...args) }
  },

  get() {
    return { errors: _errors, warnings: _warnings }
  },

  subscribe(fn) {
    listeners.add(fn)
    fn(consoleTally.get())
    return () => listeners.delete(fn)
  },

  /** Test seam. */
  _reset() {
    _errors = 0
    _warnings = 0
    listeners.clear()
  },
}

export default consoleTally
